import { Component, computed, input, OnInit, Optional, ViewChild, viewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { delay, filter, startWith } from 'rxjs';
import { BaseComponent } from '@ex/module/core/domain/base-component';
import { Chart } from '@ex/module/core/modules/chart/builder';
import { NewChartComponent } from '../new-chart/new-chart.component';
import { ExcelChartOptions } from '../../utils/new-chart-base.component';
import { ChartComponent } from '@ex/module/shared/chart/chart.component';
@Component({
  selector: 'chart-header',
  standalone: false,

  templateUrl: './chart-header.component.html',
  styleUrl: './chart-header.component.scss'
})
export class ChartHeaderComponent extends BaseComponent implements OnInit {
  readonly chart = input<Chart>();
  readonly classes = input();
  readonly legacyChart = input<ChartComponent>();
  readonly excelChartOptions = input<ExcelChartOptions>();
  @ViewChild('title') title!: HTMLElement;
  chartType: FormControl = new FormControl();
  chartTypeTour = input();
  parent = input<NewChartComponent>();
  language = input<string>('EN');
  constructor(@Optional() public component: NewChartComponent) {
    super();
  }
  ngOnInit(): void {

  }
  ngAfterViewInit(): void {
    this.addSubscription(this.chartType.valueChanges.pipe(filter(x => x!!)).subscribe(type => {
      const chart = this.chart();

      if (chart.chartTypes?.length && this.chart()?.type != type)
        this.chart()?.setType(type);
    }));
    this.chartType.setValue(this.chart()?.type)
  }


  get selectedChartTypeIcon() {
    const type = this.chart()?.type
    return this.chart()!.chartTypes.find(c => c.key == type)?.icon;
  }

  get chartTypes() {
    return this.chart()?.chartTypes.filter(x => x.key != this.chart().type);
  }

  exportRaw() {
    if (this.legacyChart()) {
      this.legacyChart()?.exportExcel();
      return;
    }
    if (this.parent())
      this.parent()?.exportExcel(this.chart()!, this.excelChartOptions());
    else
      this.component.exportExcel(this.chart()!, this.excelChartOptions());
  }
  exportPDF() {
    if (this.parent())
      this.parent()?.exportPdf(this.chart()?.id!);
    else
      this.component.exportPdf(this.chart()?.id);
  }

}
